import Button from "../../student/components/generic/button";
import { LtiConfigurationPayload } from "./Integration13";
import { IntegrationInfoType } from "./IntegrationLanding";

type Props = {
  testIntegration: () => void;
  data: LtiConfigurationPayload;
  setData: (data: LtiConfigurationPayload) => void;
  integrationLoaded: boolean;
  integration: IntegrationInfoType;
};

const EditIntegrationForm = (props: Props) => {
  return (
    <form
      className="flex max-w-lg flex-col gap-4"
      onSubmit={(e) => {
        e.preventDefault();
        props.testIntegration();
      }}
    >
      <div>
        <label
          htmlFor="issuer"
          className="block text-sm font-bold text-dm-charcoal-800"
        >
          Issuer
        </label>
        <div className="mt-1 flex flex-col gap-1">
          <input
            id="issuer"
            name="issuer"
            type={"text"}
            placeholder={props.integration.sampleIssuer}
            required
            disabled={!props.integrationLoaded}
            value={props.data.issuer}
            onChange={(e) =>
              props.setData({ ...props.data, issuer: e.target.value })
            }
            className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
          />
          <div className="flex items-center gap-2">
            <i
              className="far fa-info-circle text-sm font-normal leading-none text-dm-charcoal-500"
              aria-hidden="true"
            />
            <p className="text-xs">
              The issuer is the platform identifier for the LMS that is
              initiating the launch.
            </p>
          </div>
        </div>
      </div>
      <div>
        <label
          htmlFor="clientId"
          className="block text-sm font-bold text-dm-charcoal-800"
        >
          Client ID
        </label>
        <div className="mt-1">
          <input
            id="clientId"
            name="clientId"
            type={"text"}
            disabled={!props.integrationLoaded}
            required
            value={props.data.clientId}
            onChange={(e) =>
              props.setData({ ...props.data, clientId: e.target.value })
            }
            className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
          />
        </div>
      </div>
      <div>
        <label
          htmlFor="deploymentId"
          className="block text-sm font-bold text-dm-charcoal-800"
        >
          Deployment ID
        </label>
        <div className="mt-1">
          <input
            id="deploymentId"
            name="deploymentId"
            type={"text"}
            disabled={!props.integrationLoaded}
            required
            value={props.data.deploymentId}
            onChange={(e) =>
              props.setData({ ...props.data, deploymentId: e.target.value })
            }
            className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
          />
        </div>
      </div>
      <Button
        className="mt-6 w-full"
        submit
        disabled={!props.integrationLoaded}
      >
        Test Integration
      </Button>
    </form>
  );
};

export default EditIntegrationForm;
